var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", { ref: "validation" }, [
    _c(
      "div",
      { staticClass: "container-cadastro" },
      [
        _c("div", { staticClass: "card-header" }, [
          _vm._v("Análise do Processo " + _vm._s(_vm.processo.numeroProcesso))
        ]),
        !_vm.isValidacao
          ? _c("despachos", {
              attrs: {
                cadastroColetivo: _vm.processo.cadastroColetivo,
                despachos: _vm.historicoDespachos,
                documentosAssinados: _vm.processo.documentosAssinados
              }
            })
          : _c("validacao-edicao-cadastro", {
              attrs: {
                cadastroColetivo: _vm.cadastroColetivo,
                despachos: _vm.historicoDespachos
              },
              on: { validacaoDocumentos: _vm.documentos }
            }),
        !_vm.isVisualizar
          ? _c(
              "div",
              { staticClass: "container-analise" },
              [
                _c(
                  "div",
                  { attrs: { id: "despacho" } },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required", name: "Despacho" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Despacho:", required: true }
                                }),
                                _c("el-input", {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { type: "textarea", rows: "10" },
                                  on: {
                                    blur: function($event) {
                                      return _vm.whitespace("texto")
                                    }
                                  },
                                  model: {
                                    value: _vm.despacho.texto,
                                    callback: function($$v) {
                                      _vm.$set(_vm.despacho, "texto", $$v)
                                    },
                                    expression: "despacho.texto"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4072414400
                      )
                    })
                  ],
                  1
                ),
                _vm.isValidacao
                  ? _c(
                      "div",
                      [
                        _c("el-alert", {
                          attrs: {
                            title:
                              'O upload de anexos dos tipos "Mapa de localização" e "Leitura Mapa" substituirão os automatizados',
                            type: "warning",
                            "show-icon": "show-icon"
                          }
                        }),
                        _c("app-documentos", {
                          attrs: {
                            aba: "Anexos",
                            idUploadDocumento: "documentoAnexo",
                            titulo: "Anexos",
                            maxSize: 25000,
                            "valid-extensions": _vm.validExtensions,
                            documentos: _vm.documentos,
                            tiposDocumentos: _vm.tiposDocumentos,
                            tiposDocumentosObrigatorios: [],
                            pecasTecnicas: true,
                            observer: this.$refs.validation
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { attrs: { id: "anexos" } },
                      [
                        _c("app-label", {
                          attrs: { label: "Anexos:", required: false }
                        }),
                        _c("app-upload-area", {
                          attrs: {
                            id: "anexo",
                            target: _vm.urlUpload,
                            fileType: _vm.validExtensions,
                            onSuccess: _vm.onSuccess,
                            documento: _vm.despacho.documento
                          },
                          on: {
                            download: _vm.download,
                            removerDocumento: _vm.removerDocumento
                          }
                        })
                      ],
                      1
                    ),
                _c(
                  "div",
                  [
                    _vm.radiosAcoes.length
                      ? _c("app-radios-tramitacao", {
                          attrs: {
                            radios: _vm.radiosAcoes,
                            isDecisao: true,
                            radioInicial: _vm.radioInicial
                          },
                          on: { changeRadio: _vm.changeRadio }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("app-buttons-cadastro", {
                  attrs: {
                    isPrimeiroPasso: true,
                    isUltimoPasso: true,
                    showButtonSalvar: true
                  },
                  on: {
                    salvar: _vm.salvar,
                    cancelar: _vm.cancelar,
                    finalizar: _vm.finalizar
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.isVisualizar
          ? _c(
              "div",
              { staticClass: "buttons btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "default", name: "voltar" },
                    on: {
                      click: function($event) {
                        return _vm.voltar()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fas fa-chevron-left" }),
                      _c("b", [_vm._v("  Voltar")])
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b5b74a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5b74a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/AnaliseProcesso.vue
// module id = null
// module chunks = 